(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.EpicArtworkRightsCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  /*
   * Pure rules for the artwork-rights notice on custom-upload products
   * (owner request 2026-10-03). Once artwork is uploaded, a line under it
   * says that adding to cart confirms the customer owns the artwork or has
   * permission to print it; terms of service section 22 says the same. It
   * never blocks Add to cart (owner's call: no friction on custom sales).
   * The hidden line-item property keeps a record that the notice was shown.
   */
  var PROPERTY_NAME = '_artwork_rights';
  var PROPERTY_VALUE = 'Notice shown at upload: adding to cart confirms the customer owns this artwork or has permission to print it';

  // Upload-Lift's derived files. The main cropped upload arrives with
  // meta.variant "original" (seen on the store 2026-09-28), so only these
  // named variants are children to ignore.
  var CHILD_VARIANTS = { thumbnail: true, _original: true, _text: true, convert: true };

  function isMainFile(detail) {
    if (!detail || !detail.url || detail.parent) return false;
    var variant = detail.meta && detail.meta.variant;
    return !(variant && CHILD_VARIANTS[variant]);
  }

  /* Removing the shown file clears it; removing some other file does not. */
  function afterRemove(currentUrl, removedUrl) {
    var current = String(currentUrl || '');
    return current && current !== String(removedUrl || '') ? current : '';
  }

  return {
    PROPERTY_NAME: PROPERTY_NAME,
    PROPERTY_VALUE: PROPERTY_VALUE,
    isMainFile: isMainFile,
    afterRemove: afterRemove
  };
});
